import FeaturedProjects from "./FeaturedProjects";

const Work = () => {
  return <FeaturedProjects />;
};

export default Work;